import defaultAxios from './dataSources/default';
// functions
import log from '../utilities/log';
import umbracoBackup from './dataSources/umbracoBackup';

// constants
import { config } from '../config';

const URLS = config.URLS;

// enabling backup will use the backup umbraco database service which takes a json object
// hand copied from the endpoint.
const ENABLE_BACKUP = false;

/** reduces an array of card config objects to an object of key value pairs
 *
 * @param { Array<Objects> } cardConfigs array of config objects
 *   { key: config name, value: config value }
 *
 * @returns { Object } object mapping of key value pairs { config Name: config Value }
 *
 */
function mapConfigsToObject(cardConfigs) {
  if (!cardConfigs) return {};
  return cardConfigs.reduce((acc, cardConfig) => {
    acc[cardConfig.key] = cardConfig.values || cardConfig.value;
    return acc;
  }, {});
}


/** reduces an array of card instance objects to an object of key value pairs
 *
 * @param { Array<Objects> } cards array of config objects
 *   { key: card name, value: card configs object }
 *
 * @returns { Object } object mapping of key value pairs { card Name: card configs }
 *
 */
function mapCardsToObject(cards) {
  if (!cards.length) return {};
  return cards.reduce((acc, card) => {
    acc[card.alias] = mapConfigsToObject(card.configs);
    return acc;
  }, {});
}


/** gets all card configurations from umbraco api
 *   NB: other apis availible for more refined data requests
 * @param { Function } userGuid string customer id
 *
 * @returns { Promise<Object, error> } Promise that resolves to Object of templates
 *   and their instances/configs
 *  @example
 *   {
 *    template name: {
 *      card name: {
 *        config name: config value
 *        ...
 *      }
 *    ...
 *    }
 *    ...
 *  }
 *
 */
export function getAllCardTemplates(userGuid) {
  // umbraco backup provides a manual cache of template info
  const prom = ENABLE_BACKUP ? umbracoBackup.get() :
    defaultAxios.get(URLS.TEMPLATES_ENDPOINT.GET_ALL);

  return prom.then(({ data }) => {
    const templates = [...data, deliveredOrderCardTemplate];

    return templates.reduce((acc, template) => {
      acc[template.name] = mapCardsToObject(template.cards);
      return acc;
    }, {});
  }).catch((error) => {
    log.error(userGuid, error, 'App Failed to contact mySofologyCards Endpoint.');
    return Promise.reject(error);
  });

}

const deliveredOrderCardTemplate = {
  "cards": [
    {
      "id": 1354,
      "cardname": "OrderDeliveredCard",
      "alias": "OrderDelivered",
      "nodename": null,
      "configs": [
        {
          "key": "canDismiss",
          "value": "0"
        },
        {
          "key": "showInFeed",
          "value": "1"
        },
        {
          "key": "visibleInPages",
          "value": "135",
          "values": [
            "Home"
          ]
        },
        {
          "key": "notesPrivate",
          "value": "This card will be added by the event consumer service when receiving an order delivered message.\nDeleting or renaming this card will prevent the event consumer from working!"
        },
        {
          "key": "pushQueue",
          "value": "0"
        },
        {
          "key": "mandatory",
          "value": "0"
        },
        {
          "key": "queueMessage",
          "value": "0"
        },
        {
          "key": "title",
          "value": "Delivery Summary"
        }
      ],
      "children": null
    }
  ],
  "id": 1355,
  "name": "OrderDeliveredCard",
  "alias": "OrderDelivered"
};


// WEBPACK FOOTER //
// ./src/services/templatesService.js